<form *ngLet="{
  isOn: getField('stopEnabled').value
} as stopEnabled"
      [formGroup]="form">

  <mat-slide-toggle (change)="changedStopJob($event.checked)"
                    [formControlName]="fields.stopEnabled"
                    data-cy="triggers-add-form-stopEnabled">
    {{ 'triggers_modal_actions_stop_after' | translate }}
  </mat-slide-toggle>

  <div *ngIf="stopEnabled.isOn"
       class="stopProcess-input-container layout-row layout-align-v-start layout-align-h-center layout-wrap">

    <mat-form-field class="flex-15">
      <input [placeholder]="'triggers_modal_actions_days' | translate"
             [attr.max]="stopDaysMax"
             [formControlName]="fields.stopDays"
             matInput
             data-cy="triggers-add-form-stop-days"
             min="0"
             type="number" />
    </mat-form-field>

    <span class="flex"></span>
    <mat-form-field class="flex-15">
      <input [placeholder]="'triggers_modal_actions_hours' | translate"
             [attr.max]="stopHoursMax"
             [formControlName]="fields.stopHours"
             matInput
             data-cy="triggers-add-form-stop-hours"
             min="0"
             type="number" />
    </mat-form-field>

    <span class="flex"></span>
    <mat-form-field class="flex-15">
      <input [placeholder]="'triggers_modal_actions_minutes' | translate"
             [attr.max]="stopMinutesMax"
             [formControlName]="fields.stopMinutes"
             matInput
             data-cy="triggers-add-form-stop-minutes"
             min="0"
             type="number" />
    </mat-form-field>

    <span class="flex"></span>

    <div class="soft-stop flex-30">
      <mat-radio-group [disabled]="!stopEnabled.isOn"
                       [formControlName]="fields.stopStrategy"
                       class="layout-row layout-align-v-start layout-align-h-center">
        <mat-radio-button [value]="StopStrategy.SoftStop">
          {{ 'triggers_stop_after_stop' | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="StopStrategy.Kill">
          {{ 'triggers_stop_after_kill' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <mat-error *ngIf="form!.getError('zeroMinutes')"
               class="interval-error"
               translate>
      triggers_stop_after_interval_info
    </mat-error>
  </div>

</form>
